export default __webpack_public_path__ + "static/premio1CO-b3b29956767289869f11662ebbdc8604.png";